import { useQuery } from 'react-query'

import { usePagination } from '@webapp/core/hooks/usePagination'
import { type RepoPaginationResponse } from '@webapp/infrastructure/interfaces/repositories/RepoPaginationResponse'
import { cardRepository } from '@webapp/modules/spending-cards/data-access/repositories/CardRepository'
import {
  Card,
  type CardConstructor,
} from '@webapp/modules/spending-cards/entities/Card'
import { SpendingCardKeys } from '@webapp/modules/spending-cards/entities/enums/SpendingCardKeysEnum'

type UseQueryRequestableCardsReturn = {
  cards: Card[]
  pagination?: RepoPaginationResponse
  isFetching: boolean
  isFetched: boolean
}

export const useQueryRequestableCards = ({
  enabled,
  onSuccess,
}: {
  enabled: boolean
  onSuccess?: (cards: CardConstructor[]) => void
}): UseQueryRequestableCardsReturn => {
  const { params: paginationParams, updateNumPages } = usePagination({
    id: 'requestable-cards-list',
  })

  const { data, isFetching, isFetched } = useQuery({
    queryKey: [...SpendingCardKeys.GET_REQUESTABLE_CARDS, paginationParams],
    queryFn: () =>
      cardRepository.getRequestableCards({ params: { ...paginationParams } }),
    onSuccess: (res) => {
      if (res) {
        updateNumPages(res?.pagination?.numPages)
        onSuccess?.(res?.data)
      }
    },
    enabled,
  })

  const cards = data?.data || []

  return {
    cards: cards.map((c) => new Card(c)),
    pagination: data?.pagination,
    isFetching,
    isFetched,
  }
}
